import { Link } from 'react-router-dom'

const MenuItem = ({ label, icon, link, isMobile }) => {
  return (
    <Link to={link}>
      <div
        className={isMobile ? 'nav-btn borderless-b' : 'menu-item item-border'}
      >
        {isMobile ? (
          <i className={`fas ${icon}`} />
        ) : (
          <div className='icon'>
            <i className={`fas ${icon}`} />
          </div>
        )}
        <label>{label}</label>
      </div>
    </Link>
  )
}

export default MenuItem
